import { useApiClientStore } from '../stores/useApiClientStore';
import { NhsLoginAuthorizeResult } from '../types';
import type { ApiResponseRaw, NhsLoginAuthorizeResponse, RequestTypeBroad } from '../types';

export async function fetchNhsLoginUrlApi(
  requestType: RequestTypeBroad,
): Promise<ApiResponseRaw<NhsLoginAuthorizeResponse>> {
  const api = useApiClientStore().getClient();

  return await api.getRaw<NhsLoginAuthorizeResponse>(`/patient-portal/get-nhs-login-authorize-request?requestType=${requestType}`);
}

export async function verifyNhsLoginApi(code: string) {
  const api = useApiClientStore().getClient();
  return await api.postRaw<NhsLoginAuthorizeResult>(
    '/patient-portal/session/authenticate-using-nhs-login-code',
    {
      code,
    },
  );
}
